import { useEffect } from 'react';

/**
 * Removes the server-rendered app-shell skeleton
 * (`app/views/layouts/_static_skeleton.html.erb`) once there is something real
 * to reveal — the painted shell on the happy path, or a terminal error screen.
 *
 * Kept out of the auth/feature-flag loading path on purpose: the skeleton must
 * stay up through those fetches so it hands directly to the shell instead of
 * flashing a blank loading state. Call it from whatever owns "we're done
 * booting" (the app shell, or an error screen), not from a generic provider.
 */
export function useRemoveStaticSkeleton() {
  useEffect(() => {
    document.getElementById('static-skeleton')?.remove();
  }, []);
}
